export default __webpack_public_path__ + "static/media/givetest.9b8998b4.png";